import { render, staticRenderFns } from "./NlpAudio.vue?vue&type=template&id=54a6d89c&scoped=true&"
import script from "./NlpAudio.vue?vue&type=script&lang=js&"
export * from "./NlpAudio.vue?vue&type=script&lang=js&"
import style0 from "./NlpAudio.vue?vue&type=style&index=0&id=54a6d89c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a6d89c",
  null
  
)

export default component.exports